var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-admin-mail-list"},[(_vm.tab == 'single')?_c('single-controller',{on:{"summary":function($event){return _vm.$emit('summary', $event)}}}):(_vm.tab == 'group')?_c('group-controller'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }